module.exports = __webpack_public_path__ + "8fe3158559ef89ff2ad534b228ae757b.MP3";